export { DailyDivinationCard } from './DailyDivinationCard'
